export class RedirectError extends Error {
  constructor(public redirectUrl: string | null, public fcnName: string) {
    super('userRedirected')
    this.redirectUrl = redirectUrl
    this.name = fcnName
  }
}
